import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './PageRenderer.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const PageRenderer = () => {
  const { slug: paramSlug } = useParams();
  const location = useLocation();
  const slug = paramSlug || location.pathname.replace('/', '');
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API}/api/pages/${slug}`);
        if (!res.ok) throw new Error('Page not found');
        const data = await res.json();
        if (!data.is_active) throw new Error('Page not found');
        setPage(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, [slug]);

  if (loading) return (
    <div className="page-renderer">
      <div className="page-container"><p className="page-loading">Loading...</p></div>
    </div>
  );

  if (error) return (
    <div className="page-renderer">
      <div className="page-container">
        <div className="page-not-found">
          <h2>Page Not Found</h2>
          <p>The page you're looking for doesn't exist or has been removed.</p>
          <a href="/" className="btn-back-home">Back to Home</a>
        </div>
      </div>
    </div>
  );

  return (
    <div className="page-renderer">
      <div className="page-hero">
        <h1>{page.title}</h1>
      </div>
      <div className="page-container">
        <div className="page-content" dangerouslySetInnerHTML={{ __html: page.content }} />
      </div>
    </div>
  );
};

export default PageRenderer;
